import { createTheme } from '@material-ui/core';
const theme = createTheme({
  typography: {
    fontFamily: `"Roboto", sans-serif`,
  },
  palette: {
    primary: {
      main: '#7C01FF',
    },
    secondary: {
      main: '#ff5555',
    },
    error: { main: '#E20000' },
  },
});

export default theme;
